import {
  ApiAction,
  ApiFailureAction,
  ApiSuccessAction,
  APIGWAllowedList,
} from 'lib/types/global';
import {
  API_GATEWAY_ALLOWED_LIST,
  API_GATEWAY_ALLOWED_LIST_SUCCESS,
  API_GATEWAY_ALLOWED_LIST_FAILURE,
} from './actionTypes';

type APIGWAllowedListRequestAction = ApiAction<API_GATEWAY_ALLOWED_LIST>;
type APIGWAllowedListSuccessAction = ApiSuccessAction<
  API_GATEWAY_ALLOWED_LIST_SUCCESS,
  APIGWAllowedList
>;
type APIGWAllowedListFailureAction =
  ApiFailureAction<API_GATEWAY_ALLOWED_LIST_FAILURE>;

export interface APIGWAllowedListState extends APIGWAllowedList {
  useApiGateway: boolean;
}

export const getAPIGWAllowedList = () => ({
  endpoint: '/api-gw/hub-app-gw-allowed-list',
  type: API_GATEWAY_ALLOWED_LIST,
  silent_exception: true,
});

export const apiGWAllowedListCache = (function () {
  const cache: { [key: string]: boolean } = {};

  return {
    hasKey(key: string) {
      return key in cache;
    },
    get(key: string) {
      return cache[key];
    },
    set(key: string, value: boolean) {
      cache[key] = value;
    },
    clear() {
      Object.keys(cache).forEach(function (key: string) {
        delete cache[key];
      });
    },
  };
})();

export const isGatewayEndpoint = (
  pathname: string,
  apiGWAllowedListState: APIGWAllowedListState,
) => {
  const { useApiGateway, apiGWAllowedList } = apiGWAllowedListState;
  if (
    !pathname.startsWith('/api/') ||
    !useApiGateway ||
    apiGWAllowedList.length === 0
  ) {
    return false;
  }

  if (apiGWAllowedListCache.hasKey(pathname)) {
    return apiGWAllowedListCache.get(pathname);
  }

  for (const endpoint of apiGWAllowedList) {
    const regex = new RegExp(endpoint);
    if (regex.test(pathname.slice(4))) {
      // caching the endpoint in a dictionary to speed the operation.
      apiGWAllowedListCache.set(pathname, true);
      return true;
    }
  }

  apiGWAllowedListCache.set(pathname, false);
  return false;
};

export type APIGWAllowedListAction =
  | APIGWAllowedListRequestAction
  | APIGWAllowedListSuccessAction
  | APIGWAllowedListFailureAction;
